export default {}

/*

{"Role I want to upgrade to": [ 
    {"Role I'm at now" : "gumroad code"}
]}

*/
